import { SubscriptionType } from "../models/subscription/SubscriptionType";
import useSubscription from "./useSubscription";

export default (userId: string | undefined): SubscriptionType => {
  const subscription = useSubscription(userId);
  return subscription?.role;
};
